import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit, SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef, MatNoDataRow,
    MatRow, MatRowDef, MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {MatOption} from "@angular/material/autocomplete";
import {MatPaginator} from "@angular/material/paginator";
import {MatSelect} from "@angular/material/select";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatTooltip} from "@angular/material/tooltip";
import {CookieService} from "ngx-cookie-service";
import {DialogService} from "../../../_modal/dialog.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {OverlayContainer} from "@angular/cdk/overlay";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {environment} from "../../../../../environments/environment";
import {OT_DTO} from "../../../_models/OT_DTO";
import {RapportDTO, RapportHistory} from "../../../_models/rapport-dto";
import {RapportService} from "../../../../services/rapport-service/rapport.service";
import {Endpoints} from "../../../endpoints";
import { finalize, tap } from 'rxjs';
import { SampleService } from '../../../../services/sample-service/sample.service';
import saveAs from 'file-saver';
import { SampleDTO } from '../../../_models/sampleDTO';
import { SignatureComponent } from '../../../../signature/signature.component';
import { MatDialog } from '@angular/material/dialog';
import { LotService } from '../../../../services/lot-service/lot.service';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-report',
    standalone: true,
    providers: [DialogService, HandleErrorsService, RapportService, Endpoints],
    imports: [
        DatePipe,
        FormsModule,
        MatButton,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatCell,
        MatCellDef,
        MatCheckbox,
        MatColumnDef,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatError,
        MatFormField,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatIconModule,
        MatInput,
        MatLabel,
        MatMenu,
        MatOption,
        MatPaginator,
        MatRow,
        MatRowDef,
        MatSelect,
        MatSort,
        MatSortHeader,
        MatSuffix,
        MatTab,
        MatTabGroup,
        MatTable,
        MatTooltip,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        MatHeaderCellDef,
        MatMenuTrigger,
        NgClass,
        MatNoDataRow
    ],
    templateUrl: './reportDetail.component.html',
    styleUrl: './reportDetail.component.scss'
})
export class ReportDetailComponent implements OnInit {
   
    @Input({ required: true }) rapportId!: number;  // id du rapport parent

    rapportHistories: RapportHistory[] = [];
  
    constructor(private rapportService: RapportService,      
      private route: ActivatedRoute,
    ) {}
  
    ngOnInit(): void {
      this.route.paramMap.subscribe(params => {
        const idParam = params.get('id');
        console.log('Param id from route:', idParam);
        this.rapportId = Number(idParam);
        console.log('Converted rapportId:', this.rapportId);
        this.loadRapportHistories();
      });
      
          }
    trackById(index: number, item: any): any {
      return item.id;  // ou le nom de la propriété unique de ton item, par ex. history.id
    }
    loadRapportHistories(): void {
      console.log('Chargement des historiques pour rapport ID =', this.rapportId);
    
      this.rapportService.getRapportHistory(this.rapportId).subscribe({
        next: (data: RapportHistory[]) => {
          this.rapportHistories = data;
          console.log('Historique reçu :', this.rapportHistories);
        },
        error: (error: any) => {
          console.error('Erreur lors du chargement des historiques :', error);
        }
      });
    }
    
      downloadPdf(history: RapportHistory): void {
          this.rapportService.downloadPdf(history.id).subscribe(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `rapport_history_${history.versionNumber}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
          }, error => {
            console.error('Erreur téléchargement PDF', error);
          });
        }
        
    
}
